module.exports = __webpack_public_path__ + "img/beer_thumbnail-400x300.30c2ffe4.jpg";